import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useCoachesSection} from './CoachesSection.hook';
import {CoachesSectionProps} from './CoachesSection.types';

export const CoachesSection: React.FC<CoachesSectionProps> = ({
  allFrontline = 0,
  allGen0 = 0,
  allOrganization = 0,
  currentUserCompetency = '',
  newFrontline = 0,
  newGen0 = 0,
  newOrganization = 0,
  myTeams = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {onInfoPress, listItems, onItemPress, tt, ts} = useCoachesSection({
    allFrontline,
    allGen0,
    allOrganization,
    currentUserCompetency,
    newFrontline,
    newGen0,
    newOrganization,
    myTeams,
    onShowReport,
    onShowInfoPopover,
  });

  return (
    <MetricSection
      accessible={true}
      analyticsTitle="Coaches"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Coaches Section Information button',
      )}
      testID={MetricsSection.metricSectionCoaches}
      title={tt('heading', 'Coaches')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default CoachesSection;
